import React from 'react';
import { Link } from 'react-router-dom';

const Settings = () => {
  return (
    <div style={{padding:'1rem 1.25rem'}}>
      <h2 style={{marginTop:0}}>Settings</h2>
      <ul style={{listStyle:'none',padding:0,margin:0}}>
        <li style={{marginBottom:'0.75rem'}}>
          <Link to="/settings/qr" style={{textDecoration:'underline',color:'#1976d2'}}>Generate Marketing QR Codes</Link>
        </li>
      </ul>
    </div>
  );
};

export default Settings;
